import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {Column, FieldTableDto, TableJointure} from '@tj/tj-dmp-lib-api';
import {CompareService} from '../data-compare/compare.service';
import {Subscription} from 'rxjs';

interface ColumnData {
    tableName: string;
    propertyName: string;
}

@Component({
    selector: 'dmp-expand-data',
    templateUrl: './expand-data.component.html',
    styleUrls: ['./expand-data.component.scss'],
    standalone: false
})
export class ExpandDataComponent implements OnInit, OnDestroy, OnChanges {
    @Input() simplifiedInterface: false;
    @Input() printView = false;

    // liste des méta données des champs
    @Input() fields: FieldTableDto[];
    // Liste des colonnes de la vue
    @Input() viewCols: Column[];
    // Liste des colonnes du préset
    @Input() presetCols: string[];
    // données
    @Input() rowData: any;

    @Output() changeSortField = new EventEmitter<string[]>();
    @Output() detailRequested = new EventEmitter<{ rowData: any, rowIndex: number }>();
    @Output() manualAcquisitionRowRequested = new EventEmitter<{ rowData: any; rowIndex: number }>();

    @Input() showManualAcquisitionRowButton = false;

    @Input() tableAvecPlusieursJointures: TableJointure = null;
    @Input() partner: string;
    @Input() tenant: string;
    @Input() rowIndex: number;

    cols: ColumnData[] = [];
    sortedCols: ColumnData[] = [];

    listTable: Array<TableJointure> = [];
    valueConstraint: any;

    isCompared = false;
    disabledCompare = false;

    private sub: Subscription[] = [];

    constructor(
        public compareService: CompareService) {
    }

    ngOnDestroy(): void {
    this.sub.forEach(i => i.unsubscribe());
  }

  ngOnInit() {
      //
      this.isCompared = this.compareService.include(String(this.rowData['@id']));
      //
      this.compareService.fullObs.subscribe(value => {
          this.disabledCompare = !this.isCompared && value;
      });

      // liste des autres dépendances
      if (this.tableAvecPlusieursJointures && this.tableAvecPlusieursJointures.join.length) {
          this.listTable = this.tableAvecPlusieursJointures.join.filter(t => {
              if (!this.partner) {
                  return true;
              } else if (!t.ownerPartner) {
                  return true;
              } else if (this.partner === t.ownerPartner) {
                  return true;
              } else {
                  return false;
              }
          });
      }
      //
      this.valueConstraint = this.rowData.id;
      if (this.presetCols && this.presetCols.length > 0) {
          this.fillWithPresetCols();
      } else {
        this.fillWithCols();
      }
    }

    ngOnChanges(changes: SimpleChanges): void {
        // Not Yet
    }

    fillWithCols() {
        this.cols = this.viewCols.map(c => ({
            tableName: c.tableName,
            propertyName: c.propertyName
        }));
        this.applyColumnOrder();
    }

    fillWithPresetCols() {
        this.cols = this.presetCols.map(c => {
            return {
                tableName: c.split('.')[0],
                propertyName: c.split('.')[1]
            };
        });
        this.applyColumnOrder();
    }

    applyColumnOrder() {
        if (!this.cols || this.cols.length === 0) {
            this.sortedCols = [...this.cols];
            return;
        }
    
        const fieldOrder = this.fields.map(f => f.code);
        this.sortedCols = [...this.cols].sort((a, b) => {
            return fieldOrder.indexOf(a.propertyName) - fieldOrder.indexOf(b.propertyName);
        });
    }

    getFieldByCol(col: ColumnData) {
        return this.fields.find(f => f.table === col.tableName && f.code === col.propertyName);
    }

    addComparator() {
        this.isCompared = this.compareService.toogleCompare(String(this.rowData['@id']), this.rowData);
    }

    print() {
        console.log('print');
    }

    onOpenDetail() {
        this.detailRequested.emit({rowData: this.rowData, rowIndex: this.rowIndex});
    }

    onManualAcquisitionRow() {
        this.manualAcquisitionRowRequested.emit({ rowData: this.rowData, rowIndex: this.rowIndex });
    }

}
